import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Timestamp } from '@firebase/firestore';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { ServiceStatusesSnakeCaseEnums } from '../../../enums';
import { Service, ServiceEventEnums } from '../../../models';
import { ServicesService, SnackbarService } from '../../../services';
import { JobUploaderService } from '../../../services/standard/job-uploader.service';

@Component({
  selector: 'prism-job-upload-item',
  templateUrl: './job-upload-item.component.html',
  styleUrls: ['./job-upload-item.component.scss']
})
export class JobUploadItemComponent implements OnInit, AfterViewInit, OnDestroy {
  currentUploads$: Observable<any> = this.jobUploaderService.currentUploads$;
  address = '';
  jobDeliverPending = false;
  destroy$: Subject<void> = new Subject();
  service: Service = null;

  @Input() isSelectedJob: any;
  @Input() jobUploaded: any;
  @Input() index: any;
  @Input() globalDeliveryPending: boolean;
  @Input() deleteInProgress: boolean;

  @Input()
  set serviceInput(service: Service) {
    if (!!service) {
      this.service = service;
    }
  }

  @Output() jobDeliverPending$: EventEmitter<{ [jobId: string]: boolean }> = new EventEmitter<{ [jobId: string]: boolean }>();
  @Output() setCanDeliver: EventEmitter<{ id: string, lastDateDelivered: string, canDeliver: boolean }>
    = new EventEmitter<{ id: string, lastDateDelivered: string, canDeliver: boolean }>();

  @ViewChild('container', {static: true}) containerElement: ElementRef<HTMLDivElement>;

  constructor(private jobUploaderService: JobUploaderService,
              private snackbarService: SnackbarService,
              private servicesService: ServicesService) {
  }

  ngOnInit() {
  }


  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  deliverJob() {
    this.jobDeliverPending = true;
    this.jobDeliverPending$.emit({[this.service.id]: true});
    const {id, fromDirectory, pathToProcessorService, jobId} = this.service;
    this.jobUploaderService.deliverService({id, fromDirectory, pathToProcessorService, jobId})
      .then(() => {
        this.snackbarService.showSnackbar(`Service delivered. Member can now view assets uploaded to service ${this.service.id}`);
        this.jobDeliverPending$.emit({[this.service.id]: false});
        this.jobDeliverPending = false;
        const eventTimestamp = moment().utc().valueOf();
        this.service.timelineEvents[eventTimestamp] = {
          event: 'Service delivered',
          date: Timestamp.now(),
          eventType: ServiceEventEnums.DELIVERY
        };
        this.servicesService.updateServiceStatus(this.service.id, ServiceStatusesSnakeCaseEnums.memberReview);
        this.service.images.push(...this.service.imagesToDeliver);
        this.service.imagesToDeliver = [];

        if (!!this.servicesService.selectedService && (this.servicesService.selectedService.id === this.service.id)) {
          this.servicesService.setSelectedService(this.service);
        }

      })
      .catch(err => {
        console.error('Could not deliver job:', err);
        this.jobDeliverPending = false;

      });
  }
}
